import { render, staticRenderFns } from "./articleLabels.vue?vue&type=template&id=4cc202f0&"
import script from "./articleLabels.vue?vue&type=script&lang=js&"
export * from "./articleLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports